import React, { useState, useEffect } from 'react';
import { Modal, Box, IconButton, CircularProgress } from '@mui/material';
import { Close as CloseIcon, Download as DownloadIcon } from '@mui/icons-material';

/**
 * Modal xem chi tiết ảnh — dùng chung cho cửa sổ chat và menu chat.
 * Props:
 * - open: boolean
 * - src: URL đầy đủ tới ảnh (không null)
 * - alt?: string
 * - onClose: () => void
 */
const ImagePreviewModal = ({ open, src, alt = 'image', onClose }) => {
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (open) setLoading(true);
	}, [open, src]);

	if (!src) return null;

	const handleDownload = (e) => {
		e.stopPropagation();
		const a = document.createElement('a');
		a.href = src;
		a.download = alt || 'image';
		a.target = '_blank';
		a.rel = 'noreferrer';
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	};

	return (
		<Modal
			open={ open }
			onClose={ onClose }
			disableScrollLock
			sx={ {
				display: 'flex', alignItems: 'center', justifyContent: 'center',
				bgcolor: 'rgba(0,0,0,0.85)',
			} }
		>
			<Box
				onClick={ onClose }
				sx={ {
					position: 'relative', width: '100%', height: '100%',
					display: 'flex', alignItems: 'center', justifyContent: 'center',
					outline: 'none',
				} }
			>
				{/* Close */ }
				<IconButton
					onClick={ onClose }
					sx={ {
						position: 'absolute', top: 16, right: 16,
						bgcolor: 'rgba(255,255,255,0.15)',
						color: '#fff', zIndex: 2,
						'&:hover': { bgcolor: 'rgba(255,255,255,0.3)' },
					} }
				>
					<CloseIcon />
				</IconButton>
				{/* Download */ }
				<IconButton
					onClick={ handleDownload }
					sx={ {
						position: 'absolute', top: 16, right: 64,
						bgcolor: 'rgba(255,255,255,0.15)',
						color: '#fff', zIndex: 2,
						'&:hover': { bgcolor: 'rgba(255,255,255,0.3)' },
					} }
				>
					<DownloadIcon />
				</IconButton>

				{ loading && (
					<CircularProgress sx={ { position: 'absolute', color: '#fff' } } />
				) }
				<Box
					component="img"
					src={ src }
					alt={ alt }
					onClick={ (e) => e.stopPropagation() }
					onLoad={ () => setLoading(false) }
					onError={ () => setLoading(false) }
					sx={ {
						maxWidth: '95vw', maxHeight: '92vh',
						objectFit: 'contain',
						borderRadius: 2,
						boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
						display: loading ? 'none' : 'block',
					} }
				/>
			</Box>
		</Modal>
	);
};

export default ImagePreviewModal;
